import React from 'react'
import { Tooltip, Empty } from 'antd'
import _ from 'lodash'
import { injectIntl } from 'react-intl'
import { Amount } from 'components/Amount'
import { marketingPlanURL, parseLocalTimeByPattern } from 'services/utils'
import FinanceRow from 'components/FinanceRow'
import style from './style.module.scss'

const SalesTable = injectIntl(({ commissions, intl: { formatMessage } }) => {
  if (!commissions || commissions.length < 1) {
    return (
      <Empty
        className={style.placeholder}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <>
            {formatMessage({ id: 'page.dashboard.sales.placeholder.no-sales' })}
            <br />
            <a href={marketingPlanURL} target="_blank" rel="noopener noreferrer">
              {formatMessage({ id: 'page.dashboard.sales.placeholder.explore-marketing-plan' })}
            </a>
          </>
        }
      />
    )
  }

  return (
    <table className={style.table}>
      <tbody>
        {commissions.map(commission => {
          // title
          const title = _.get(commission, 'payment.product.title', '')

          // date
          let date = _.get(commission, 'createdAt', null)
          const [dateString, dateTimeString] = parseLocalTimeByPattern(
            date,
            'DD MMM YYYY&LL – HH:mm',
          ).split('&')
          date = <Tooltip title={dateTimeString}>{dateString}</Tooltip>

          // description
          const productPrice = (
            <Amount value={_.get(commission, 'payment.product.price', 0)} currencyCode="rur" />
          )
          const formattedPercent = `${commission.percent || 0}%`
          const description = (
            <>
              {formattedPercent}{' '}
              {formatMessage({
                id: 'page.dashboard.sales.from',
              })}{' '}
              {productPrice}
            </>
          )

          return (
            <FinanceRow
              key={commission.id}
              title={title}
              date={date}
              amount={_.get(commission, 'amount', 0)}
              description={description}
            />
          )
        })}
      </tbody>
    </table>
  )
})

export default SalesTable
